import { useFormik } from 'formik'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import * as Yup from 'yup'

import { caregiverAPI } from '../api/services/dd_panel_caregiver'
import {
  CareGiver,
  CareGiverDetails
} from '../api/services/dd_panel_caregiver/types.ts'

export const useCareGiverForm = () => {
  const [loading, setLoading] = useState(false)
  const [careGiverData, setCareGiverData] = useState<CareGiver | null>(null)
  const [careGiverId, setCareGiverId] = useState<number | null>(null)
  const [initialValues, setInitialValues] = useState<CareGiverDetails>({
    first_name: '',
    last_name: '',
    email: ''
  })

  useEffect(() => {
    const getCompany = async () => {
      setLoading(true)
      try {
        const response = await caregiverAPI.getCareGiver()
        if (response.status === 200 && response.data.length > 0) {
          setInitialValues(response.data[0])
          setCareGiverData(response.data[0])
          setCareGiverId(response.data[0].id)
        }
      } catch (error) {
        toast.error(error as string)
      } finally {
        setLoading(false)
      }
    }
    ;(async () => await getCompany())()
  }, [])

  const onSubmitSaveData = async (
    values: {
      first_name: string
      last_name: string
      email: string
    },
    setSubmitting: (isSubmitting: boolean) => void
  ) => {
    const toastId = toast.loading('Wysyłanie danych')
    setSubmitting(true)

    try {
      const response = careGiverId
        ? await caregiverAPI.putCareGiver(careGiverId, values)
        : await caregiverAPI.postCareGiver(values)

      const existsErrors =
        response?.error && Object.keys(response.error).length > 0

      if (existsErrors) {
        if (response.status === 404) {
          toast.error(response.error)
        }
      }

      if (
        response.status === 200 ||
        response.status === 201 ||
        response.status === 204
      ) {
        formik.setStatus(true)

        setCareGiverData((prevData) => ({
          ...prevData!,
          ...values
        }))

        toast.update(toastId, {
          render: 'Dane opiekuna zostały zapisane',
          type: 'success',
          delay: 500,
          isLoading: false,
          autoClose: 4000
        })
      }
      if (response.status === 400) {
        toast.dismiss(toastId)
      }
    } catch {
      toast.dismiss(toastId)
    } finally {
      setSubmitting(false)
    }
  }

  const validationSchema = Yup.object({
    first_name: Yup.string().required('To pole jest wymagane'),
    last_name: Yup.string().required('To pole jest wymagane'),
    email: Yup.string()
      .required('To pole jest wymagane')
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        'Wprowadź prawidłowy adres email'
      )
  })

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      await onSubmitSaveData(values, setSubmitting)
    },
    enableReinitialize: true
  })

  return { formik, loading, careGiverData }
}
